import { useEffect } from 'react';
import { getQuestionDifficultyLevels } from '../thunks/question-thunks';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';

export const useQuestionDifficultyLevels = () => {
  const dispatch = useDispatch();
  const { difficultyLevels } = useSelector((state: RootStateOrAny) => state.question);

  useEffect(() => {
    dispatch(getQuestionDifficultyLevels());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { difficultyLevels };
};
